import { applyMiddleware, combineReducers, createStore } from "redux";
import { dbotReducer } from "dbot/src/DbotReducer";
import { dbotMiddleware } from "dbot/src/DbotMiddleware";
import { createLogger, thunk } from "redux-middleware";
import { loggerMiddleware } from "./LoggerMiddleware";
import { DbotMiddlewarePlugin } from "./DbotMiddlewarePlugin";
import { clientIdReducer } from "./ClientIdReducer";
import { progressReducer } from "./ProgressReducer";
import { modalsReducer } from "common/src/modal/ModalReducer";
import { notificationsReducer } from "common/src/notification/NotificationsReducer";
import { addAndInitBlock } from "dbot/src/DbotActions";
import { fetchBlock } from "dbot/src/business/DbotHelperFunctions";
import { sendLog } from "logger/api"

const extraReducer = window.EXTRA_DBOT_REDUCER ? window.EXTRA_DBOT_REDUCER : (state = {}) => state;

const extraMiddleware = store => next => action => {
  if (!window.EXTRA_MIDDLEWARE) return next(action)
  window.EXTRA_MIDDLEWARE(action, store.getState(), store.dispatch, addAndInitBlock, fetchBlock, sendLog)
  return next(action)
}

export const store = createStore(
  combineReducers({
    dbotReducer,
    clientId: clientIdReducer,
    extra: extraReducer,
    progress: progressReducer,
    modals: modalsReducer,
    notification: notificationsReducer,
  }),
  {},
  applyMiddleware(extraMiddleware, dbotMiddleware(DbotMiddlewarePlugin), createLogger(), loggerMiddleware, thunk)
);


